import { DisclaimerData } from "@/pages/quiz/base/questions/disclaimerAcknowledgment/common";
import clsx from "clsx";
import CustomCheckbox from "@/pages/quiz/base/questions/disclaimerAcknowledgment/components/CustomCheckbox";

interface IProps<T> {
  disclaimerData: DisclaimerData<T>;
  checked: boolean;
  onChange: (v: T) => void;
}

const DisclaimerItem = <T extends string>({
  disclaimerData,
  checked,
  onChange,
}: IProps<T>) => {
  return (
    <div
      className={clsx(
        "flex flex-col gap-3 border rounded-3xl border-gray py-4",
        checked && "!border-dark-purple"
      )}
    >
      <h3 className="font-medium text-lg px-5">{disclaimerData.title}</h3>
      <div className="border-b border-gray px-5" />
      <div className="quiz-description max-h-[300px] overflow-auto space-y-3 px-3 mx-2 text-sm pb-4">
        <div className="text-[15px]">{disclaimerData.body}</div>

        <CustomCheckbox
          onChange={onChange}
          isChecked={checked || false}
          name={disclaimerData.name}
          label={disclaimerData.label}
        />
      </div>
    </div>
  );
};

export { DisclaimerItem };
